import { get } from 'lodash';

function getZendeskUrl(ownProps) {
  const returnToUrl = get(ownProps, 'location.query.return_to', null);
  return /zendesk/.test(returnToUrl) ? returnToUrl : null;
}

export default getZendeskUrl;
